import {createContext} from 'react';
import defaultConfig from 'src/internal/revamp/config/defaultConfig';

import type {DataConfig} from 'src/internal/revamp/config/types';

export default createContext<DataConfig>(defaultConfig);
